<template>
  <v-card>
    <v-toolbar color=primary>
      <v-toolbar-title class="white--text">
        Refrigerant Simulation
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text>

      <v-container
        fluid
        grid-list-lg
      >
        <v-layout row wrap align-center>
          <v-flex xs12 md6>
            <h4 class="display-1">
              COP: {{result.COP}}
            </h4 >
          </v-flex>

          <v-flex xs12 md6>
            <img
              :src="this.result.img"
              height="325"
              width="475"
            >
          </v-flex>

          <v-flex xs12 md6>
            <h5 class="title text-md-left">
              T2:
            </h5>
            <v-slider
              v-model="t2"
              always-dirty
              thumb-label="always"
              max="340"
              min="270"
            ></v-slider>
          </v-flex>

          <v-flex xs12 md6>
            <h5 class="title text-md-right">
              Subcooling Delta T:
            </h5>
            <v-slider
              v-model="subcool_t"
              always-dirty
              thumb-label="always"
              max="80"
              min="0"
            ></v-slider>
          </v-flex>

          <v-flex xs12 md6>
            <h5 class="title text-md-left">
              T3:
            </h5>
            <v-slider
              v-model="t3"
              always-dirty
              thumb-label="always"
              max="370"
              min="240"
            ></v-slider>
          </v-flex>

          <v-flex xs12 md6>
            <h5 class="title text-md-right">
              Superheat Delta T:
            </h5>
            <v-slider
              v-model="superheat_t"
              always-dirty
              thumb-label="always"
              max="110"
              min="0"
            ></v-slider>
          </v-flex>

          <v-flex xs12 md6>
            <h5 class="title text-md-left">
              ETA_COM:
            </h5>
            <v-slider
              v-model="eta_com"
              always-dirty
              thumb-label="always"
              max="1"
              min="0"
              step="0.01"
            ></v-slider>
          </v-flex>

          <v-flex xs12 md6>
            <v-select
              v-model="refrigerant"
              :items="items"
              label="Refrigerant"
            ></v-select>
          </v-flex>

        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>


<script>
import debounce from 'lodash.debounce'
import {getRefrigerantProp} from '../helper'
  export default {

    watch: {
      t2 () {
        this.update()
      },
      subcool_t () {
        this.update()
      },
      t3 (){
        this.update()
      },
      superheat_t (){
        this.update()
      },
      eta_com (){
        this.update()
      },
      refrigerant () {
        this.update()
      },
      img (){
        this.update()
      },
    },
    methods: {
      update: debounce(
        function run(){
          this.newupdate()
        },
        500
      ),
      async newupdate () {
        let r = await getRefrigerantProp(this.t2, this.subcool_t, this.t3, this.superheat_t, this.eta_com, this.refrigerant, this.img)
        this.result = r.result
      }
    },

    data () {
      return {
        result: {
          COP: null,
          H: [null],
          T: [null],
          p: [null],
          theoretical_COP: null,
          img: 'https://i.imgur.com/PRs2OSg.png'
        },
        t2: 300,
        subcool_t: 2,
        t3: 270,
        superheat_t: 2,
        eta_com: 0.8,
        refrigerant: 'R410a',
        items: ['R410a', 'R134a']
      }
    }
}
</script>
